var exports = {
  "zr": "MacPermissionPrompt.module__root___dTlFZz",
  "Vs": "MacPermissionPrompt.module__tile___dTlFZz",
  "DD": "MacPermissionPrompt.module__title___dTlFZz",
  "X7": "MacPermissionPrompt.module__purpose___dTlFZz",
  "vQ": "MacPermissionPrompt.module__purposeLine___dTlFZz",
  "o1": "MacPermissionPrompt.module__actions___dTlFZz",
  "E3": "MacPermissionPrompt.module__primaryActions___dTlFZz",
  "zB": "MacPermissionPrompt.module__primary___dTlFZz",
  "qD": "MacPermissionPrompt.module__notNow___dTlFZz",
  "TQ": "MacPermissionPrompt.module__allowed___dTlFZz",
};

module.exports = exports;
